import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { HelmetProvider } from "react-helmet-async";
import reducers from "./reducers";

import App from "./App";

const store = configureStore({ reducer: reducers });

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>

  <Provider store={store}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Provider>,
  // {/* </React.StrictMode> */}
);
